// Barre de navigation des pages publiques (accueil, guides, légal, contact).
//
// Collante, blanche, un filet en bas dès qu'on a défilé. Sur téléphone, le
// menu se déplie sous la barre. Habillage : styles/landing.css (.lp-nav).
import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { UBrand } from './Logo'
import { Menu, Close } from '../landing/Icons'
import { useT } from '../../lib/i18n'

export default function Navbar () {
  const t = useT()
  const [open, setOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  const onHome = useLocation().pathname === '/'
  const anchor = href => (onHome ? href : `/${href}`)

  useEffect(() => {
    let raf = 0
    function compute () { raf = 0; setScrolled(window.scrollY > 8) }
    function onScroll () { if (!raf) raf = requestAnimationFrame(compute) }
    compute()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => { window.removeEventListener('scroll', onScroll); if (raf) cancelAnimationFrame(raf) }
  }, [])

  useEffect(() => {
    if (!open) return
    const onKey = e => { if (e.key === 'Escape') setOpen(false) }
    window.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => { window.removeEventListener('keydown', onKey); document.body.style.overflow = '' }
  }, [open])

  const close = () => setOpen(false)

  return (
    <header className={`lp-nav${scrolled || open ? ' lp-nav--on' : ''}${open ? ' lp-nav--menu' : ''}`}>
      <div className="lp-wrap lp-nav__in">
        <Link to="/" aria-label={t.nav.home} onClick={close} className="lp-nav__brand"><UBrand /></Link>

        <nav className={`lp-nav__links${open ? ' lp-nav__links--open' : ''}`}>
          {t.nav.links.map(l => (
            <a key={l.href} href={anchor(l.href)} className="lp-nav__link" onClick={close}>{l.label}</a>
          ))}
          <Link to="/guides" className="lp-nav__link" onClick={close}>{t.footer.guides}</Link>
          <span className="lp-nav__sep" aria-hidden="true" />
          <Link to="/login" className="lp-nav__link lp-nav__link--alt" onClick={close}>{t.nav.login}</Link>
          <Link to="/register" className="lp-btn lp-btn--main lp-btn--sm" onClick={close}>{t.nav.start}</Link>
        </nav>

        <button
          className="lp-nav__burger"
          onClick={() => setOpen(!open)}
          aria-label={open ? t.nav.closeMenu : t.nav.openMenu}
          aria-expanded={open}
        >
          {open ? <Close /> : <Menu />}
        </button>
      </div>
    </header>
  )
}
